import * as React from 'react';
import { CommonsCmsDynamicPage } from '../rql';
import Metadata from './metadata';

interface IProps {
  page: CommonsCmsDynamicPage.Pages;
}

export default function CmsPageMetadata({ page }: IProps) {
  return (
    <Metadata
      title={page.metaTitle || page.title}
      description={page.metaDescription || page.description}
      image={page.image?.imageUrl}
      metaImage={page.metaImage?.imageUrl}
      noIndex={page.noIndex}
    />
  );
}



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/commons/src/components/cms_page_metadata.tsx